import React from 'react';
import { useTranslation } from 'react-i18next';
import AnimateOnScroll from './AnimateOnScroll';

export default function Differentiator() {
  const { t } = useTranslation();

  const items = [
    t('Differentiator.item1'),
    t('Differentiator.item2'),
    t('Differentiator.item3'),
    t('Differentiator.item4'),
    t('Differentiator.item5'),
    t('Differentiator.item6'),
  ];

  return (
    <section className="py-20" style={{ background: '#f8f9fe' }} id="differentiator">
      <div className="container">
        <AnimateOnScroll>
          <div className="text-center mb-12 max-w-2xl mx-auto">
            <p className="t-h1">{t('Differentiator.label')}</p>
            <h2 className="t-h2">{t('Differentiator.title')}</h2>
            <p style={{ color: '#6b7280', lineHeight: 1.7, fontSize: '0.95rem' }}>
              {t('Differentiator.intro')}
            </p>
          </div>
        </AnimateOnScroll>

        <AnimateOnScroll animation="fadeUp" delay={100}>
          <div className="max-w-3xl mx-auto rounded-2xl p-8 bg-white border" style={{ borderColor: '#e5e7eb' }}>
            <p
              className="font-bold mb-5"
              style={{ fontFamily: '"Wix Madefor Display", sans-serif', color: '#010C66', fontSize: '1rem' }}
            >
              {t('Differentiator.customersDefineLabel')}
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3 mb-6">
              {items.map((item, i) => (
                <div key={i} className="flex items-center gap-3">
                  <div
                    className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0"
                    style={{ background: '#f0f2ff' }}
                  >
                    <svg width="10" height="10" viewBox="0 0 24 24" fill="none">
                      <path d="M20 6L9 17l-5-5" stroke="#010C66" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <span style={{ color: '#374151', fontWeight: 500, fontSize: '0.9rem' }}>{item}</span>
                </div>
              ))}
            </div>
            <div className="h-px mb-6" style={{ background: '#e5e7eb' }} />
            <p style={{ color: '#6b7280', lineHeight: 1.7, fontSize: '0.9rem' }}>
              {t('Differentiator.outro')}
            </p>
          </div>
        </AnimateOnScroll>
      </div>
    </section>
  );
}
